import { ActionKeys } from '~/actions/constants';
import * as routingActions from '~/actions/routing.actions';
import { push, replace } from 'connected-react-router';
import { QS_LOCAL_STORAGE_KEY } from '~/constants/local-storage-keys';
import * as qs from 'qs';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getLocation, getParsedQS } from '~/selectors/router.selectors';
import { readFromLocalStorage, saveInLocalStorage } from '~/utils/local-storage';
import { ApplicationState } from '../../store';

function* changeQueryParams(action: ReturnType<typeof routingActions.changeQueryString>) {
  const location = yield select((state: ApplicationState) => state.router!.location);
  const newQueryParams = {
    ...action.payload,
  };
  const queryString = qs.stringify(newQueryParams);
  yield put(push(`${location.pathname}?${queryString}`));
}

function* updateQueryParams(action: ReturnType<typeof routingActions.updateQueryParams>) {
  const location = yield select((state: ApplicationState) => state.router!.location);
  const currentQueryParams = qs.parse(location.search.substring(1));
  const newQueryParams = {
    ...{ sort_by: '_score', order_by: 'desc' },
    ...currentQueryParams,
    ...action.payload,
  };
  const queryString = qs.stringify(newQueryParams);
  yield put(push(`${location.pathname}?${queryString}`));
}

function* removeQueryParam(action: ReturnType<typeof routingActions.removeQueryParam>) {
  const location = yield select((state: ApplicationState) => state.router!.location);
  const currentQueryParams = qs.parse(location.search.substring(1));
  delete currentQueryParams[action.payload.name];
  const newQueryParams = {
    ...currentQueryParams,
  };
  yield put(push(`${location.pathname}?${qs.stringify(newQueryParams)}`));
}

function* removeQueryParams(action: ReturnType<typeof routingActions.removeQueryParams>) {
  const location = yield select((state: ApplicationState) => state.router!.location);
  const currentQueryParams = qs.parse(location.search.substring(1));
  action.payload.name.forEach((param) => delete currentQueryParams[param]);
  const newQueryParams = {
    ...currentQueryParams,
  };
  yield put(push(`${location.pathname}?${qs.stringify(newQueryParams)}`));
}

function* updateQueryParam(action: ReturnType<typeof routingActions.updateQueryParam>) {
  const location = yield select((state: ApplicationState) => state.router!.location);
  const currentQueryParams = qs.parse(location.search.substring(1));
  const newQueryParams = {
    ...{ sort_by: '_score', order_by: 'desc' },
    ...currentQueryParams,
    [action.payload.name]: action.payload.value,
  };
  yield put(push(`${location.pathname}?${qs.stringify(newQueryParams)}`));
  yield storeCurrentQueryParams();
}

function* storeCurrentQueryParams() {
  const currentQS = yield select(getParsedQS);
  yield call(saveInLocalStorage, QS_LOCAL_STORAGE_KEY, JSON.stringify(currentQS));
}

function* restoreQueryParams() {
  const storedQSString = readFromLocalStorage(QS_LOCAL_STORAGE_KEY);
  if (storedQSString) {
    const storedQS = JSON.parse(storedQSString);

    // In case an empty object was stored
    if (Object.keys(storedQS).length > 0) {
      const location = yield select(getLocation);
      const queryString = qs.stringify(storedQS);

      yield put(replace(`${location.pathname}?${queryString}`));
    }
  }
}

export default [
  takeLatest(ActionKeys.CHANGE_QUERY_PARAMS, changeQueryParams),
  takeLatest(ActionKeys.UPDATE_QUERY_PARAM, updateQueryParam),
  takeLatest(ActionKeys.UPDATE_QUERY_PARAMS, updateQueryParams),
  takeLatest(ActionKeys.STORE_CURRENT_QUERY_PARAMS, storeCurrentQueryParams),
  takeLatest(ActionKeys.RESTORE_QUERY_PARAMS, restoreQueryParams),
  takeLatest(ActionKeys.REMOVE_QUERY_PARAM, removeQueryParam),
  takeLatest(ActionKeys.REMOVE_QUERY_PARAMS, removeQueryParams),
];
